import {SubscriptionStateModel, SubscriptionStateModelBillingInfo, SubscriptionStateModelInfo} from "./models/SubscriptionStateModel";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {PackagesModel} from "./models/PackagesModel";
import {DestinationTypeEnum} from "../destinations/models";
import {PackageType} from "../../../../infrastructure/enums/packageType";

const initial: SubscriptionStateModel = {
    upgradeModal: {
        show: false,
        packageType: null,
        forceSubscription: false,
        currentPlan: null,
        currentPeriod: null,
        packages: []
    },
    freemiumModal: {
        show: false
    },
    info: null,
    billingInfo: {
        name: '',
        email: ''
    }
}

const {actions, reducer} = createSlice({
    name: 'subscription',
    initialState: initial,
    reducers: {
        setShowUpgradeModal: (state,
                              action: PayloadAction<{
                                  state?: boolean,
                                  packageType?: Nullable<PackageType>,
                                  forceSubscription?: boolean,
                                  currentPlan?: string | null,
                                  currentPeriod?: "Monthly" | "Yearly" | null
                              }>) => {
            state.upgradeModal.show = action.payload.state ?? true
            state.upgradeModal.packageType = action.payload.packageType ?? initial.upgradeModal.packageType
            state.upgradeModal.forceSubscription = action.payload.forceSubscription ?? initial.upgradeModal.forceSubscription
            state.upgradeModal.currentPlan = action.payload.currentPlan ?? initial.upgradeModal.currentPlan
            state.upgradeModal.currentPeriod = action.payload.currentPeriod ?? initial.upgradeModal.currentPeriod
        },
        setShowFreemiumModal: (state, action: PayloadAction<{ state?: boolean }>) => {
            state.freemiumModal.show = action.payload.state ?? true
        },
        setUpgradeModalPackages: (state, action: PayloadAction<PackagesModel[] | null>) => {
            state.upgradeModal.packages = action.payload ?? initial.upgradeModal.packages
        },
        setSubscriptionInfo: (state, action: PayloadAction<Nullable<SubscriptionStateModelInfo>>) => {
            state.info = action.payload ?? initial.info
        },
        setBillingInfo: (state, action: PayloadAction<SubscriptionStateModelBillingInfo>) => {
            state.billingInfo = action.payload ?? initial.info
        }
    }
})

export const subscriptionReducer = reducer
export const subscriptionReducerActions = actions